<template>
    <div>
        <b-form @submit.prevent="search" @keydown.enter.prevent>
            <b-form-group
                label="Search"
                label-for="search"
            >
                <b-input-group>
                    <b-form-input
                        ref="search-term"
                        type="search"
                        v-model="search_term"
                        :disabled="searching"
                        @keydown.enter.prevent="search"
                    />
                    <b-input-group-append>
                        <b-btn type="submit" variant="outline-secondary" :disabled="searching">
                            <font-awesome-icon :icon="['fad', 'search']" />
                        </b-btn>
                    </b-input-group-append>
                    <b-input-group-append v-if="searched">
                        <b-btn variant="outline-danger" :disabled="searching" @click.prevent="clearSearch">
                            <font-awesome-icon :icon="['fad', 'backspace']" />
                        </b-btn>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>

            <div v-if="searching" class="mb-3">
                <b-spinner label="Spinning"></b-spinner>
            </div>

            <div v-else>
                <b-list-group v-if="filtered_sbp_assets && filtered_sbp_assets.length" class="my-3">
                    <b-list-group-item
                        v-for="(asset, index) in filtered_sbp_assets"
                        :key="index"
                        class="d-flex align-items-center"
                    >
                        <sbp-asset
                            :publication="publication"
                            :asset="asset"
                            :related_media="article_related_media"
                            :type="type"
                            @link="linkItem"
                            @unlink="unlinkItem"
                        />
                    </b-list-group-item>
                </b-list-group>

                <b-alert variant="danger" :show="searched && !filtered_sbp_assets.length">
                    0 results
                </b-alert>
            </div>
        </b-form>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>

import SbpAsset from '@/components/modals/media/Asset'

export default {
    data: () => ({
        sbp_assets: [],

        search_term: '',

        searching: false,
        searched: false
    }),
    props: [
        'publication',
        'article',
        'type',
        'article_related_media'
    ],
    components: {
        SbpAsset
    },
    computed: {
        filtered_sbp_assets () {
            return _.filter(this.sbp_assets, asset => {
                return asset
            })
        }
    },
    methods: {
        search () {
            if (this.search_term) {
                this.searched = false
                this.searching = true
                this.sbp_assets = []

                this.axios.get('/api/media/search_media_images/'+this.search_term)
                .then(response => {
                    if (response.data) {
                        this.sbp_assets = response.data;
                        this.searched = true;
                        this.searching = false;
                    }
                })
                .catch(error => {
                    if (error) {
                        this.sbp_assets = [];
                        this.searched = false;
                        this.searching = false;
                    }
                })

            }
        },
        clearSearch () {
            this.search_term = ''
            this.searched = false
            this.sbp_assets = []

            if (this.$refs['search-term']) {
                this.$refs['search-term'].focus()
            }
        },
        linkItem (item, width, position, size) {
            this.$set(item, 'linking', true)
            this.$emit('link', item, width, position, size)
        },
        unlinkItem (item) {
            this.$set(item, 'linking', false)
            this.$emit('unlink', item)
        }
    },
    mounted () {
        if (this.$refs['search-term']) {
            this.$refs['search-term'].focus()
        }
    }
}
</script>
